var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasurement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#050505",
    d: "M25.492,1.171c-0.609-0.61-1.674-0.61-2.283,0l-3.557,3.557L4.269,20.111 c-0.053,0.052-0.093,0.116-0.118,0.186L0.331,31.03c-0.064,0.182-0.019,0.385,0.118,0.521c0.095,0.095,0.223,0.146,0.354,0.146 c0.056,0,0.113-0.009,0.167-0.028l10.733-3.82c0.004-0.002,0.007-0.006,0.011-0.008c0.065-0.025,0.126-0.061,0.175-0.111 L27.05,12.57l0,0l0.044-0.044l0.178-0.178l0,0l3.557-3.557c0.305-0.305,0.473-0.71,0.473-1.142s-0.168-0.837-0.473-1.142 L25.492,1.171z M11.447,26.759c-3.785-1.995-5.525-4.771-6.099-5.899c-0.056-0.11-0.099-0.2-0.136-0.279L20.005,5.788l6.207,6.207 L11.447,26.759z M4.696,21.749c0.746,1.31,2.43,3.676,5.613,5.535l-8.683,3.09L4.696,21.749z M30.122,8.084l-3.203,3.204 l-6.206-6.206l3.204-3.203c0.232-0.232,0.637-0.232,0.869,0l5.337,5.337c0.116,0.116,0.18,0.271,0.18,0.435 S30.238,7.968,30.122,8.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#050505",
    d: "M20.653,8.504c-0.195-0.195-0.512-0.195-0.707,0l-12.22,12.22c-0.195,0.195-0.195,0.512,0,0.707 c0.098,0.098,0.226,0.146,0.354,0.146s0.256-0.049,0.354-0.146l12.22-12.22C20.848,9.016,20.848,8.7,20.653,8.504z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#050505",
    d: "M23.7,11.15c-0.195-0.195-0.512-0.195-0.707,0L10.576,23.567c-0.195,0.195-0.195,0.512,0,0.707 c0.098,0.098,0.226,0.146,0.354,0.146s0.256-0.049,0.354-0.146L23.7,11.857C23.896,11.662,23.896,11.345,23.7,11.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#050505",
    d: "M7.607,0.447c-0.596-0.596-1.564-0.597-2.16,0l-5,5c-0.596,0.595-0.596,1.564,0,2.16l6.66,6.66 c0.098,0.098,0.226,0.146,0.354,0.146s0.256-0.049,0.354-0.146c0.195-0.195,0.195-0.512,0-0.707L6.11,11.855L9.285,8.68 c0.195-0.195,0.195-0.512,0-0.707s-0.512-0.195-0.707,0l-3.175,3.175L3.686,9.432l1.757-1.758c0.195-0.195,0.195-0.512,0-0.707 s-0.512-0.195-0.707,0L2.979,8.725L1.154,6.9c-0.206-0.206-0.206-0.54,0-0.746l5-5c0.207-0.205,0.54-0.204,0.746,0l6.661,6.661 c0.195,0.195,0.512,0.195,0.707,0s0.195-0.512,0-0.707L7.607,0.447z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#050505",
    d: "M24.893,17.733c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707l6.66,6.66 c0.206,0.206,0.206,0.54,0,0.746l-5,5c-0.206,0.206-0.539,0.205-0.746,0l-1.637-1.637l3.175-3.175c0.195-0.195,0.195-0.512,0-0.707 s-0.512-0.195-0.707,0l-3.175,3.175l-1.716-1.716l1.758-1.758c0.195-0.195,0.195-0.512,0-0.707s-0.512-0.195-0.707,0l-1.758,1.758 l-1.893-1.893c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707l6.66,6.66C24.691,31.851,25.082,32,25.473,32 c0.391,0,0.782-0.149,1.08-0.447l5-5c0.596-0.595,0.596-1.564,0-2.16L24.893,17.733z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurement);
export default __webpack_public_path__ + "static/media/measurement.002ff5efd41192f8c8cf93cd8d264554.svg";
export { ForwardRef as ReactComponent };